export default __webpack_public_path__ + "static/media/Thaumaturge's Tunic of Sovereign Rule.964f18e5.jpg";